import React from 'react';
import _ from 'lodash';
import Moment from 'moment';

import InfinityScrollLoad from './InfinityScrollLoad';
import { NotificationService } from '../services/Notification';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { REQUEST_PARAMS } from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import NotificationUtility from '../utilities/notificationUtility';
import { NotificationLevel } from '../utilities/notificationConstants';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { isNullOrEmpty } from '../utilities/stringUtil';
import TransmissionErrorResult from './modals/TransmissionErrorResult';
import {
  NOTIFICATIONS_FILTER_TYPE,
  NOTIFICATION_LOAD_DURATION,
} from '../utilities/constants';
import { FieldService } from '../services/Fields';
import { Information } from './modals/common/';
import { UserAccessExpiredModal } from './modals/UserAccessExpiredModal';
import SessionStorageService from '../services/utilities/SessionStorageService';
/**
 * @description ヘッダー通知
 */
export default class HeaderNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationOpenFlag: false, // 通知コンポーネント開閉用フラグ
      notificationList: [], // 取得通知情報
      hoverNoticeId: null, // ホバー通知ID
      loaded: false, // ページングロード用
      // unreadCount: 0,
      selectedNotification: {}, //選択されたお知らせ
      transmissionErrorResultDialogOpened: false, //送信履歴ダイアログ開閉用フラグ
      visibleUserAccessExpiredModal: false,
      visibleNoUserAccessInfo: false,
    };

    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-notification-${this.id}`;
    this.userId = LocalStorageService.getUserId(); // ユーザーID
    this.parent = React.createRef();
  }

  componentDidUpdate() {
    const { notificationOpenFlag } = this.state;
    if (notificationOpenFlag) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener('click', this.handleClickOutsideOfComponent);
    }
    if (!notificationOpenFlag) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener('click', this.handleClickOutsideOfComponent);
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (this.parent.current.contains(e.target)) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({
      notificationOpenFlag: false,
      notificationList: [],
    });
    // 閉じた場合にバッジカウント更新のためにAPI実行
    // this.refreshUnreadCount();
  };

  handleShowForm = () => {
    this.setState({ notificationOpenFlag: !this.state.notificationOpenFlag });
  };

  // refreshUnreadCount() {
  //   this.props.callback();
  // }

  componentWillReceiveProps(next) {
    this.setState({ isExistUreadNotice: next.isUnread });
  }

  // /**
  //  * 親から既読/未読アイコンを表示するためのStateを更新する
  //  * 自分自身で呼んでも特に問題ないです
  //  * @param {number} count
  //  */
  // fireRender(count) {
  //   this.setState({ unreadCount: count });
  // }

  /**
   * @description 通知情報取得
   */
  getNotifications = notify => {
    if (this.state.loaded) {
      notify();
      return;
    }

    const { notificationList } = this.state;
    const params = {
      offset: _.size(notificationList),
      limit: REQUEST_PARAMS.parentLimit,
      order: 'display_start_date_desc',
      isQuiet: true,
      include_usage_end_date_flag: NOTIFICATIONS_FILTER_TYPE.EXCLUDE_EXPIRED,
      field_id: SessionStorageService.getFieldId()
    };

    NotificationService.list(params).then(response => {
      if (response.result) {
        const { notices } = response.data.entities;
        if (_.isEmpty(notices)) {
          this.setState({ loaded: true });
        } else {
          this.setState({
            notificationList: [...notificationList, ...notices],
            loaded: false, // scrollのため
          });
        }
        notify();

        // 通知一覧APIのトリガーとして、前回の操作時間を削除して再ロードする
        SessionStorageService.removeLastNotificationLoaded();

        // 重要なお知らせを更新する
        this.props.callback();
      }
    });
  };

  /**
   * @description 通知情報レンダリング
   * @param {object} notification 通知情報
   */
  renderNotificationList = notification => {
    /*
     * 通知弱：常に背景グレー表示
     * 通知強：未読であれば背景黄色表示/既読であれば背景グレー表示
     */
    const isMark =
      !notification.read_flag &&
      notification.level === NotificationLevel.strong;

    return (
      <li
        key={notification.id}
        className='notification-item'
        onClick={() => this.notificationSelect(notification)}
        onMouseEnter={() => this.notificationHover(notification.id)}
        onMouseLeave={() => this.notificationUnHover()}
        style={{
          backgroundColor: isMark ? '#fcfade' : '#F2F2F2',
          width: '328px',
        }}
      >
        <div className='notification-item__header'>
          <i
            className={`notification-item__icon ${NotificationUtility.hasIcon(
              notification
            )}${notification.read_flag ? '' : '--blue'}`}
          />
          <div className='notification-item__title'>{notification.title}</div>
          <div className='notification-item__time'>
            {Moment(notification.display_start_date).fromNow(true)}
            経過
          </div>
        </div>
        <div className='notification-item__body'>
          <div className='notification-item__info'>{notification.content}</div>
        </div>
      </li>
    );
  };

  /**
   * @description 通知ホバー
   * @param {number} noticeId 通知ID
   */
  notificationHover = noticeId => {
    this.setState({ hoverNoticeId: noticeId });
  };

  /**
   * @description 通知ホバー解除
   */
  notificationUnHover = () => {
    this.setState({ hoverNoticeId: null });
  };

  /**
   * @description ユーザが対象現場に接続できるかを確認する
   * @param {object} notification 通知情報
   */
  getUserAccessStatus = async confirmingItem => {
    // field_idがない現場の遷移先である場合はそのままスキップする
    if (!confirmingItem.field_id) {
      return 'SKIP';
    }

    return await FieldService.checkAccessible(confirmingItem.field_id)
      .then(response => {
        if (response) {
          this.setState({
            visibleUserAccessExpiredModal: !response.data.accessible,
          });
        } else {
          this.setState({
            visibleNoUserAccessInfo: true,
          });
        }
        return response;
      })
      .catch(error => {
        // 元請BOXの管理者から現場監督が削除される場合、404なるためCatchする
        if (error.status === 404) {
          this.setState({
            visibleNoUserAccessInfo: true,
          });
        }
      });
  };

  closeUserAccessExpiredModal = () => {
    this.setState({
      visibleUserAccessExpiredModal: false,
    });
  };

  closeNoUserAccessInfoDialog = () => {
    this.setState({
      visibleNoUserAccessInfo: false,
    });
  };

  /**
   * @description 通知選択
   * @param {object} notification 通知情報
   */
  notificationSelect = async notification => {
    NotificationUtility.read(notification);
    const response = await this.getUserAccessStatus(notification);
    if (response) {
      if (response === 'SKIP' || response.data.accessible) {
        if (
          notification.message_type_id === 304 &&
          !isNullOrEmpty(notification.param1)
        ) {
          this.transmissionErrorNotificationSelect(notification);
          return;
        }

        if (notification.level === NotificationLevel.weak) {
          NotificationUtility.executeActionNotificationOtherStrong(
            notification.message_type_id,
            {
              id: this.userId,
              display_start_date: notification.display_start_date,
              param1: notification.param1,
              field_id: notification.field_id,
              target_date: notification.target_date,
              notificationId: notification.id,
              param_json: notification.param_json,
            },
            this.props.vw
          );
        } else {
          NotificationUtility.executeActionNotificationStrong(
            notification.message_type_id,
            {
              id: this.userId,
              display_start_date: notification.display_start_date,
              param1: notification.param1,
              field_id: notification.field_id,
              target_date: notification.target_date,
              notificationId: notification.id,
              param_json: notification.param_json,
            },
            this.props.vw
          );

          // 通知一覧APIのトリガーとして、前回の操作時間を削除して再ロードする
          SessionStorageService.removeLastNotificationLoaded();
        }
      }

      // 通知を選択したら通知一覧を閉じる
      this.toggleNotification();
    }
  };

  transmissionErrorNotificationSelect = notification => {
    this.setState({
      selectedNotification: notification,
      transmissionErrorResultDialogOpened: true,
    });
  };

  toggleNotification = () => {
    const { notificationOpenFlag } = this.state;
    // 閉じた状態のときに
    if (!notificationOpenFlag) {
      this.getNotifications(() => {});
    } else {
      // 閉じた場合にバッジカウント更新のためにAPI実行
      // this.refreshUnreadCount();
    }
    this.setState({
      loaded: false,
      notificationList: [],
      notificationOpenFlag: !notificationOpenFlag,
    });
  };

  render() {
    const {
      loaded,
      notificationOpenFlag,
      notificationList,
      unreadCount,
      selectedNotification,
      transmissionErrorResultDialogOpened,
    } = this.state;
    const badgeClassName =
      unreadCount > 0 ? 'notification unread' : 'notification';

    return (
      <React.Fragment>
        <div className='global-header__notification'>
          <div id='notification' ref={this.parent}>
            <div>
              <span
                className={badgeClassName}
                onClick={this.toggleNotification}
              >
                <i className='i-bell--dark i-3x' aria-hidden='true' />
                {/* // https://e-reverse.backlog.jp/view/BLDE_V2-15432 仕様変更
                <span
                  className='notifications-badge'
                  style={{ display: unreadCount == 0 ? 'none' : 'inline' }}
                >
                  {unreadCount > 99 ? '+99' : unreadCount}
                </span> */}
              </span>
            </div>
            <div
              id='notification-dropdown'
              className={`dropdown dropdown--notification${
                notificationOpenFlag ? ' show' : ''
              }`}
            >
              <div className='dropdown__item'>
                <div id={this.targetId} className='notification-list'>
                  <ul className='notification-list__list'>
                    {_.map(notificationList, (notification, index) => {
                      return this.renderNotificationList(notification, index);
                    })}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(notificationList)}
                      callback={this.getNotifications}
                      no_message={true}
                    />
                  </ul>
                  {_.isEmpty(notificationList) ? (
                    !loaded ? (
                      <div className='indicator' />
                    ) : (
                      <div className='notification-list__message'>
                        <span>{messageUtility.getMessage('I-000-033')}</span>
                      </div>
                    )
                  ) : (
                    ''
                  )}
                </div>
                <div className='notification-list__all'>
                  <button
                    className='btn'
                    tabIndex={-1}
                    onClick={() => {
                      masterSlideLoader.show('Notices', {
                        state: {},
                      });
                    }}
                  >
                    すべての通知を確認
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TransmissionErrorResult
          fieldId={selectedNotification.field_id}
          checkInOutLogTransmissionHistoryId={selectedNotification.param1}
          isOpened={transmissionErrorResultDialogOpened}
          onClose={() => {
            this.setState({
              selectedNotification: {},
              transmissionErrorResultDialogOpened: false,
            });
          }}
        />
        <UserAccessExpiredModal
          visible={this.state.visibleUserAccessExpiredModal}
          onClose={this.closeUserAccessExpiredModal}
        />
        <Information
          title='ユーザー稼働情報取得不可'
          visible={this.state.visibleNoUserAccessInfo}
          message={'この現場でユーザの稼働状況を確認できませんでした。'}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={this.closeNoUserAccessInfoDialog}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderNotifications.jsx